<app-card-form
  [createButtonLabel]="'addFirmModal.buttonTitle' | translate"
  [cardTitle]="'addFirmModal.modalTitle' | translate"
  [mode]="mode"
  [useSmallButtons]="false"
  [displayMode]="'modal'"
  [isSaving]="isSaving"
  [showClose]="true"
  [addCancelOnShowMode]="false"
  (dismissModal)="activeModal.dismiss()"
  (createItem)="onSubmit()"
  (editItem)="onSubmit()"
  (cancelEdit)="onCancelEdit()"
>
  <form [formGroup]="signupForm">
    <div class="mb-3">
      <label for="country"
        >{{ "addFirmModal.fields.country.label" | translate }}
        <span class="text-danger">*</span></label
      >
      <div class="mb-12">
        <app-dropdown-select
          [defaultValue]="formControls.country.value"
          formControlName="country"
          [inputItems]="countries"
          [isMultiSelect]="false"
          [placeHolder]="'addFirmModal.fields.country.placeholder' | translate"
          [itemValueKey]="'@id'"
          [itemLabelKey]="'name'"
          [searchKey]="'name'"
        />
      </div>
      <div
        class="invalid-feedback"
        *ngIf="submitted && signupForm.get('country')?.hasError('required')"
      >
        {{ "addFirmModal.fields.country.requiredError" | translate }}
      </div>
    </div>

    <div class="mb-3">
      <label for="regNo">{{
        "addFirmModal.fields.regNo.label" | translate
      }}</label>
      <input
        type="text"
        formControlName="regNo"
        class="form-control"
        id="regNo"
        placeholder="{{ 'addFirmModal.fields.regNo.placeholder' | translate }}"
      />
    </div>

    <div class="mb-3">
      <label for="name"
        >{{ "addFirmModal.fields.name.label" | translate }}
        <span class="text-danger">*</span></label
      >
      <input
        type="text"
        formControlName="name"
        class="form-control"
        id="name"
        [ngClass]="{
          'is-invalid': submitted && formControls.name.errors
        }"
        placeholder="{{ 'addFirmModal.fields.name.placeholder' | translate }}"
      />
      <div
        class="invalid-feedback"
        *ngIf="submitted && signupForm.get('name')?.hasError('required')"
      >
        {{ "addFirmModal.fields.name.requiredError" | translate }}
      </div>
    </div>

    <div>
      <p class="mb-0">
        {{ "addFirmModal.termsAndConditions.text" | translate }}
        <a
          href="/assets/cgv/CGVVesperV_01_01_2023.pdf"
          class="text-primary"
          target="_blank"
        >
          {{ "addFirmModal.termsAndConditions.link.text" | translate }}
        </a>
        {{ "addFirmModal.termsAndConditions.privacyPolicy" | translate }}
      </p>
    </div>
  </form>
</app-card-form>
